import Icons from "assets/icons";
import CustomButton from "components/partials/custom-button/custom-button";
import React from "react";
const StepNavigation = ({
  onClickNext,
  onClickBack,
  disabledNext,
  disabledSave,
  onClickSave,
  isSaving,
  isSaved,
  isCheckout = false,
}) => {
  const getSavedStatus = () => {
    if (isSaved) {
      return "Saved";
    } else if (isSaving) {
      return "Saving";
    } else {
      return "Save";
    }
  };
  const getNextStepLabel = () => {
    if (isCheckout && isSaved) {
      return "See Published Models";
    } else if (isCheckout && !isSaved) {
      return "Publish Model";
    } else {
      return "Next Step";
    }
  };
  return (
    <div className="mt-5 flex justify-between">
      <CustomButton
        variant="secondary"
        iconBefore={
          <Icons.Arrow aria-label="Back" customClass="h-full rotate-180 w-4" />
        }
        onClick={onClickBack}
      >
        Back
      </CustomButton>
      <div className="flex gap-2">
        {!isCheckout && (
          <CustomButton
            variant="primary"
            onClick={onClickSave}
            disabled={disabledSave}
            iconBefore={
              isSaving && (
                <Icons.Spinner customClass="h-full w-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-900" />
              )
            }
          >
            {getSavedStatus()}
          </CustomButton>
        )}
        <CustomButton
          variant="primary"
          iconAfter={<Icons.Arrow aria-label="Next" customClass="h-full w-4" />}
          onClick={onClickNext}
          disabled={disabledNext}
        >
          {getNextStepLabel()}
        </CustomButton>
      </div>
    </div>
  );
};

export default StepNavigation;
